// SPDX-License-Identifier: AGPL-3.0-or-later

export interface MessageDeleteNotice {
	channelId: string;
	messageId: string;
}

type MessageDeleteListener = (notice: MessageDeleteNotice) => void;
const messageDeleteListeners = new Set<MessageDeleteListener>();

export function subscribeMessageDelete(listener: MessageDeleteListener): () => void {
	messageDeleteListeners.add(listener);
	return () => {
		messageDeleteListeners.delete(listener);
	};
}

export function notifyMessageDelete(notice: MessageDeleteNotice): void {
	for (const listener of messageDeleteListeners) {
		listener(notice);
	}
}
